import KeenSlider from 'keen-slider';

export const CredentialCarousel = {
  init: function () {
    this.cacheSelectors();
    this.bindEvents();
  },

  cacheSelectors: function () {
    this.carouselContainers = document.querySelectorAll('.credentials');
    this.carouselInstances = [];
    this.isMobile = window.matchMedia('(max-width: 768px)');
  },

  bindEvents: function () {
    this.carouselContainers.forEach((container) => {
      const sliderElement = container.querySelector('#credential--slider');

      const prevButton = sliderElement.closest('.credentials')?.querySelector('.arrow__prev');
      const nextButton = sliderElement.closest('.credentials')?.querySelector('.arrow__next');

      if (!sliderElement) return;

      const options = this.getOptions();
      const sliderInstance = new KeenSlider(sliderElement, options);

      const updateButtons = () => {
        const { rel, slides } = sliderInstance.track.details;
        prevButton?.classList.toggle('arrow--disabled', rel === 0);
        nextButton?.classList.toggle('arrow--disabled', rel === slides.length - 1);
      };

      sliderInstance.on('created', updateButtons);
      sliderInstance.on('slideChanged', updateButtons);

      prevButton?.addEventListener('click', () => sliderInstance.prev());
      nextButton?.addEventListener('click', () => sliderInstance.next());

      this.carouselInstances.push(sliderInstance);
    });
    this.isMobile.addEventListener('change', this.handleResize.bind(this));
  },

  getOptions: function () {
    return {
      loop: false,
      mode: 'snap',
      rtl: false,
      slides: {
        perView: this.isMobile.matches ? 1.3 : 3,
        spacing: 20,
      },
    };
  },

  handleResize: function () {
    // Atualiza as configurações de todos os carrosséis
    this.carouselInstances.forEach((sliderInstance) => {
      const options = this.getOptions();
      sliderInstance.update({
        slides: options.slides,
      });
    });
  },
};

CredentialCarousel.init();



